$(document).ready(function () {

  displayItems();

  let $masonryContainers = $('.masonryContainer'); // Select all Masonry containers

  // Initialize Masonry for each container
  $masonryContainers.each(function () {
    let $masonryContainer = $(this);
    let itemsToShow = parseInt($masonryContainer.attr('data-item-initial'), 10); // Number of items to show initially
    let $items = $masonryContainer.find('.wall_category_block');

    // Hide extra items initially and show the first batch
    $items.hide().slice(0, itemsToShow).show();

    // Initialize Masonry
    $masonryContainer.masonry({
      itemSelector: '.wall_category_block',
      percentPosition: true,
      transitionDuration: '0.3s'
    });

    // Trigger layout to ensure initial placement
    setTimeout(function(){
      $masonryContainer.masonry('layout');
    }, 100);

    // Check if the "Load More" button should be visible on page load
    let totalItems = $items.length;
    if (totalItems > itemsToShow) {
      $masonryContainer.next('.load_more_button').fadeIn();
    } else {
      $masonryContainer.next('.load_more_button').fadeOut();
    }
  });

  // Filter change event
  $('.wall_filter input').on('change', function () {
    let listItem = $(this).closest('li');

    // Uncheck all filters first
    $('.wall_filter input').prop('checked', false).closest('li').removeClass('active');

    // Check the clicked filter and add 'active' class
    $(this).prop('checked', true);
    listItem.addClass('active');

    let subpage = $(this).closest('label')[0]?.dataset?.subpage;
    let subpageTitle = $(this).closest('label')[0].innerText;
    if (subpage) {
     fetch(subpage)
        .then(res => res.text())
        .then(html => {
          const newMasonry = new DOMParser().parseFromString(html, 'text/html').querySelector('.masonryContainer');
          document.querySelector('.masonryContainer').replaceWith(newMasonry);
          displayItems();
          window.history.pushState({}, subpageTitle, subpage);
      });
    }
  });

  // Load More functionality
  $('.load_more_button').on('click', function () {
    let $masonryContainer = $(this).prev('.masonryContainer'); // Assuming button is right after container
    let itemsToShow = parseInt($masonryContainer.attr('data-item-initial'), 10);
    let $items = $masonryContainer.find('.wall_category_block');
    let visibleItemsCount = $masonryContainer.find('.masonry-visible').length;

    // Show the next batch of filtered items
    let newItems = $items.slice(visibleItemsCount, visibleItemsCount + itemsToShow);

    // Append the new items to the container
    let $newItems = $(newItems).show().addClass('masonry-visible');
    $masonryContainer.append($newItems);

    // Trigger Masonry layout again to adjust positions of all the items
    setTimeout(function(){
      $masonryContainer.masonry('appended', $newItems);
    }, 100);


    // Reinitialize the videos after appending new items
    reinitializeVideos();

    // Hide Load More button if no more items to show
    if ($items.length <= visibleItemsCount + itemsToShow) {
      $(this).fadeOut();
    }
  });

  // Function to display the first set of items and handle the 'Load More' logic
  function displayItems() {
    let $masonryContainers = $('.masonryContainer');
    $masonryContainers.each(function () {
      let $masonryContainer = $(this);
      let $items = $masonryContainer.find('.wall_category_block');
      let itemsToShow = parseInt($(this).attr('data-item-initial'), 10);

      // Hide all items first
      $items.hide().removeClass('masonry-visible');

      // Show only the first 'itemsToShow' filtered elements
      $items.slice(0, itemsToShow).show().addClass('masonry-visible');

      // Reinitialize Masonry
      $masonryContainer.masonry('destroy'); // Destroy previous Masonry instance
      $masonryContainer.masonry({
        itemSelector: '.masonry-visible', // Only visible items
        columnWidth: '.wall_category_block',
        percentPosition: true,
        transitionDuration: '0.3s'
      });

      // Trigger Masonry layout once again to fix positioning
      setTimeout(() => {
        $masonryContainer.masonry('layout');
      }, 100);

      // Show or hide Load More button based on filtered items
      if ($items.length > itemsToShow) {
        $masonryContainer.next('.load_more_button').fadeIn();
      } else {
        $masonryContainer.next('.load_more_button').fadeOut();
      }
    });
  }

  // Listen for Firework custom events
  document.addEventListener('fw:storyblock:render', function() {
    adjustLayoutUponFireworkRender();
  });

  document.addEventListener('fw:embed-feed:render', function() {
    adjustLayoutUponFireworkRender();
  });

  // Update grid layout when Firework is injected dynamically
  function adjustLayoutUponFireworkRender() {
    let $masonryContainers = $('.masonryContainer');
    $masonryContainers.each((index, container) => $(container).masonry('layout'));
  }

  // Function to reinitialize Firework videos smoothly
  function reinitializeVideos() {
    document.querySelectorAll("fw-storyblock").forEach(video => {
      let parent = video.parentNode;
      let clone = video.cloneNode(true);
      parent.replaceChild(clone, video);
    });
  }
});
